module.exports = __webpack_public_path__ + "img/ИФ-1(А)-045.424d070a.png";